import React from "react";
import Range from "./range";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { DEFAULT_RANGE } from "./lib/constant";

const RangeList = (props) => {
    const defaultValue = props.defaultValue ? props.defaultValue : DEFAULT_RANGE;

    const addRange = () => {
        const ranges = props.ranges;
        props.updateState(props.name, [...ranges, { ...defaultValue }]);
    };

    const updateRange = (id, payload) => {
        const newRanges = [...props.ranges];
        newRanges[id] = payload;

        props.updateState(props.name, newRanges);
    };

    const deleteRange = (id) => {
        const newRanges = [...props.ranges];
        newRanges.splice(id, 1);
        props.updateState(props.name, newRanges);
        document.getElementsByName("newRangeSlider")[0].focus({ preventScroll: true });
    };

    const ranges = props.ranges.map((range, i) => {
        return <Range range={range} key={`range${i}of${props.ranges.length}`} id={i} updateRange={updateRange} delete={deleteRange} />;
    });

    return (
        <div className="range-list">
            {ranges}
            <button name="newRangeSlider" className="button -small" onClick={addRange}>
                <FontAwesomeIcon icon={faPlus} /> Range Slider
            </button>
        </div>
    );
};

export default RangeList;
